import { DueDiligencePage } from './DueDiligence';
import { createDueDiligenceHandle } from './handle';

export default {
  Component: DueDiligencePage,
  createHandle: createDueDiligenceHandle
};
